import type { ApiFlow } from '../types'

export const spaHostedOAuthFlow: ApiFlow = {
  id: 'spa.hosted-oauth',
  appTypes: ['spa'],
  title: 'Hosted OAuth (browser PKCE)',
  summary:
    'Redirect the browser to the authorization endpoint with PKCE, handle the callback, then exchange the code at the token endpoint.',
  steps: [
    {
      id: 'discovery',
      title: 'Discovery (optional)',
      when: 'App boot — cache issuer metadata',
      method: 'GET',
      path: '/.well-known/openid-configuration',
      requestBody: undefined,
      responseVariants: [
        {
          label: 'success',
          status: 200,
          body: {
            issuer: '{{ISSUER}}',
            authorization_endpoint: '{{ISSUER}}/oauth2/auth',
            token_endpoint: '{{ISSUER}}/oauth2/token',
            jwks_uri: '{{ISSUER}}/.well-known/jwks.json',
          },
          nextStepId: 'authorize',
        },
      ],
    },
    {
      id: 'authorize',
      title: 'Authorize redirect',
      when: 'User taps Sign in',
      method: 'GET',
      path: '/oauth2/auth',
      query: {
        response_type: 'code',
        client_id: '{{CLIENT_ID}}',
        redirect_uri: '{{REDIRECT_URI}}',
        scope: 'openid profile',
        code_challenge: '<s256-challenge>',
        code_challenge_method: 'S256',
        state: '<csrf-state>',
      },
      responseVariants: [
        {
          label: 'browser redirect',
          status: 302,
          body: { note: 'User signs in on hosted UI; callback receives ?code=...&state=...' },
          nextStepId: 'token',
        },
      ],
    },
    {
      id: 'token',
      title: 'Exchange authorization code',
      when: 'Callback route receives code and state',
      method: 'POST',
      path: '/oauth2/token',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      requestBody: {
        grant_type: 'authorization_code',
        code: '<code-from-callback>',
        redirect_uri: '{{REDIRECT_URI}}',
        client_id: '{{CLIENT_ID}}',
        code_verifier: '<original-verifier>',
      },
      responseVariants: [
        {
          label: 'success',
          status: 200,
          body: {
            access_token: 'eyJ...',
            token_type: 'bearer',
            expires_in: 3600,
            id_token: 'eyJ...',
          },
        },
      ],
    },
  ],
}
